import type { ITaxonomy } from '$shared/interfaces/api/ITaxonomy';
import BaseModel from './BaseModel';

export class TaxonomyModel extends BaseModel<ITaxonomy> {
  public get id(): string {
    return this.response?.id || '';
  }

  public get code(): string {
    return this.response?.code || '';
  }

  public get grouping(): string {
    return this.response?.grouping || '';
  }

  public get classification(): string {
    return this.response?.classification || '';
  }

  public get specialization(): string {
    return this.response?.specialization || '';
  }

  public get section(): string {
    return this.response?.section || '';
  }

  public get displayName(): string {
    return this.response?.displayName || '';
  }

  public get parsedName(): string {
    return `${this.displayName} (${this.code})`;
  }
}
